import type React from 'react'
import {
  createContext,
  useContext,
  useSyncExternalStore,
} from 'react'

import { type useStore } from 'slab/hooks/useStore'

type HeadlessListboxState = {
  selectedOption: string | null;
}

interface HeadlessListboxContextType {
  controlRef: React.RefObject<HTMLElement>;
  listRef: React.RefObject<HTMLDivElement>;
  registerOption: (id: string) => () => void;
  selectOption: (item: string) => void;
  store: ReturnType<typeof useStore<HeadlessListboxState>>;
}

export const HeadlessListboxContext = createContext<HeadlessListboxContextType>({
  controlRef: { current: null },
  listRef: { current: null },
  registerOption: () => () => {},
  selectOption: () => {},
  store: {
    subscribe: () => () => {},
    setState: () => {},
    snapshot: () => ({ selectedOption: null }),
    emit: () => {},
  },
})

export function useHeadlessListboxContext () {
  return useContext(HeadlessListboxContext)
}

export function useHeadlessListboxState<T> (selector: (state: HeadlessListboxState) => T) {
  const { store } = useContext(HeadlessListboxContext)
  const callback = () => selector(store.snapshot())
  return useSyncExternalStore(store.subscribe, callback, callback)
}
